import { useEffect, useState } from "react";
import api from "../lib/api";
import { Star, Phone } from "lucide-react";

export default function TileLayers() {
  const [layers, setLayers] = useState([]);
  useEffect(() => { api.get("/tile-layers").then(r => setLayers(r.data)); }, []);

  return (
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16" data-testid="layers-page">
      <p className="label-eyebrow">Craftsmen</p>
      <h1 className="font-editorial text-5xl sm:text-6xl tracking-editorial mt-3 mb-4">Master tile layers</h1>
      <p className="text-[#5C5C5C] max-w-2xl mb-12">
        Vetted professionals with decades of tile-work experience. Choose the tile-laying option at checkout and we'll share the top 5 profiles via WhatsApp.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {layers.map(l => (
          <div key={l.id} className="border border-[#1A1A1A]/10 flex" data-testid={`layer-${l.id}`}>
            <div className="w-32 h-40 bg-[#F0EFEA] flex-shrink-0 img-zoom">
              <img src={l.photo_url} alt={l.name} className="w-full h-full object-cover" />
            </div>
            <div className="flex-1 p-6">
              <p className="label-eyebrow">{l.experience_years} years · {l.address}</p>
              <h3 className="font-editorial text-2xl mt-1">{l.name}</h3>
              <div className="flex items-center gap-1 mt-1 text-sm">
                <Star className="w-4 h-4 fill-[#1E2C5A] text-[#1E2C5A]" strokeWidth={1.5} /> {l.rating}
              </div>
              <p className="text-sm text-[#5C5C5C] mt-3 leading-relaxed">{l.bio}</p>
              <p className="text-sm text-[#1E2C5A] mt-4 flex items-center gap-2">
                <Phone className="w-4 h-4" strokeWidth={1.5} /> {l.contact}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
